import { useEffect } from 'react';
import { useStore } from './useStore';
import { todayKey } from '@/lib/format';
import { msUntilNextMidnight } from '@/lib/today';

/**
 * Garantit que le store est sur la bonne clé `today`.
 * Programme un timer ciblé sur le prochain minuit local pour basculer
 * automatiquement sans recharger la page. Vérifie aussi au retour de
 * visibilité (l'app peut avoir été en arrière-plan plusieurs heures).
 */
export const useToday = () => {
  const currentKey = useStore(s => s.todayKey);
  const rolloverDay = useStore(s => s.rolloverDay);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const check = () => {
      const k = todayKey();
      if (k !== useStore.getState().todayKey) {
        void rolloverDay(k);
      }
    };

    const schedule = () => {
      if (timeoutId) clearTimeout(timeoutId);
      const ms = Math.max(1_000, msUntilNextMidnight() + 100);
      timeoutId = setTimeout(() => {
        check();
        schedule();
      }, ms);
    };

    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        check();
        schedule();
      }
    };

    schedule();
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [rolloverDay]);

  return currentKey;
};
